import { api } from "./api";

export const sellersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSellers: builder.query({
      query: () => "api/Sales/Sellers",
      providesTags: ["sellers"],
    }),
    addSeller: builder.mutation({
      query: (formData) => ({
        url: "api/Sales/Sellers",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["sellers"],
    }),
    deleteSeller: builder.mutation({
      query: (sliderId) => ({
        url: `api/Sales/Sellers?SellerId=${sliderId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["sellers"],
    }),
  }),
});

export const {
  useGetSellersQuery,
  useAddSellerMutation,
  useDeleteSellerMutation,
} = sellersApi;
